import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import {
  Container,
  Image,
  ImageWrapper,
  Name,
} from "../../../sharable/EncarteProduct/EncarteProduct.styles";
import {
  NAME_ABOVE_PRODUCT_LAYOUT,
  NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
  NAME_BENEATH_PRODUCT_LAYOUT,
  PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  THREE_COLUMNS_PRODUCT_LAYOUT,
  TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
} from "../EncarteConstants";
import WorkspaceContext from "../../WorkspaceContext";
import Loading from "../../../sharable/Loading";
import ProductActionBox from "../../../sharable/EncarteProduct/ProductActionBox";
import useCanvasProductInteractions from "../../../sharable/EncarteProduct/useCanvasProductInteractions";

const TotalAmountWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ canvasScale }) => 4 * canvasScale}px;
`;

const TotalAmountText = styled.span`
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
  text-align: center;
  color: ${({ productStyles }) => productStyles?.secondaryTxtColor || "#111"};
  background-color: ${({ productStyles }) =>
    productStyles?.secondaryBgColor || "#fff"};
  padding: ${({ canvasScale }) => `${4 * canvasScale}px ${8 * canvasScale}px`};
  border-radius: ${({ canvasScale }) => 12 * canvasScale}px;
  font-size: ${({ fontSize, canvasScale }) =>
    Math.max(Number(fontSize || 32) * 1.7 * canvasScale, 12)}px;
`;

export default function CestaBasicaKitProduct({
  styles,
  product,
  canvasScale,
  index,
  isProductClickable,
  productsLength,
}) {
  const [productStyles, setProductStylesStyles] = useState();

  const { isDownloadingEncarteProductImages } = useContext(WorkspaceContext);
  const {
    isSelected,
    handleProductClick,
    handleEditClick,
    handleStyleClick,
    handleCloseClick,
  } = useCanvasProductInteractions({
    index,
    isProductClickable,
  });

  useEffect(() => {
    setProductStylesStyles(product.styles);
  }, [product.styles]);

  // Quantity is mandatory for kit visualization; fallback avoids blank values.
  const quantity = product?.quantity ?? 1;
  const measurement = String(product.measurement || "UND").toUpperCase();

  return (
    <>
      {productStyles ? (
        <Container
          selected={isSelected}
          isProductClickable={isProductClickable}
          productLayout={productStyles.productLayout}
          font={styles.fontFamily}
          txtColor={productStyles.txtColor}
          bgColor={productStyles.bgColor}
          canvasScale={canvasScale}
          className="product"
          key={`grid-product-${product.id}`}
          row={productStyles.gridRow}
          column={productStyles.gridColumn}
          name={product.name}
          productsLength={productsLength}
          onClick={handleProductClick}
        >
          {isProductClickable && isSelected && (
            <ProductActionBox
              onEdit={handleEditClick}
              onStyle={handleStyleClick}
              onClose={handleCloseClick}
            />
          )}
          <ImageWrapper>
            {!product.displayUrl && isDownloadingEncarteProductImages && (
              <Loading
                txt={"Carregando imagem"}
                size={productStyles.fontSize}
              />
            )}
            <Image
              canvasScale={canvasScale}
              url={product.displayUrl}
              className="product-image"
              pId={product.id}
              imageZoom={productStyles.imageZoom}
            />
          </ImageWrapper>

          <Name
            productLayout={productStyles.productLayout}
            canvasScale={canvasScale}
            fontSize={productStyles.fontSize}
            bgColor={productStyles.bgColor}
            txtColor={productStyles.txtColor}
            className="product-name"
          >
            {product.name}
          </Name>

          {/* Price area is repurposed to show quantity + unit for the kit format. */}
          <TotalAmountWrapper className="price" canvasScale={canvasScale}>
            <TotalAmountText
              canvasScale={canvasScale}
              fontSize={productStyles.fontSize}
              productStyles={productStyles}
            >
              <span className="quantity">{quantity}</span>
              <span className="measurement">{measurement}</span>
            </TotalAmountText>
          </TotalAmountWrapper>
        </Container>
      ) : (
        <Loading color={"black"} txt={"Carregando estilos"} />
      )}
    </>
  );
}
